import moment from 'moment';

import { TFilter } from '@/common/components/redesigned/Filter/types/filter';
import Constants from '@/common/constants';

import { TDashboardsTableFilter, TEventsTableFilter } from '../../types/dashboards';

const DAYS_RANGE = 15;

export const getEventsTableParams = (
  isSystemEvent: boolean,
  params: Partial<TDashboardsTableFilter> = {},
  filter: TEventsTableFilter = {},
): TFilter => ({
  startDate: isSystemEvent ? undefined : moment().format(Constants.DATE_FORMATS['YYYY-MM-DD']),
  endDate: isSystemEvent ? undefined : moment().add(DAYS_RANGE, 'days').format(Constants.DATE_FORMATS['YYYY-MM-DD']),
  isIncreasingOrder: isSystemEvent ? false : undefined,
  isSystemEvent,
  regionRfIds: filter.subjectRfIds ?? params?.subjectRfIds,
  partnerCountryId: filter.countryId ?? params?.countryId,
  typeId: filter.typeEventId ?? params?.typeEventId,
  significantFlag: filter.significantFlag || undefined,
  includeSystemEventsWithoutRegionFilter: isSystemEvent ? params?.includeSystemEventsWithoutRegionFilter : undefined,
});
